var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ObservationPage',{on:{"back":_vm.backToReception,"deleted":_vm.backToReception}})
}
var staticRenderFns = []

export { render, staticRenderFns }